import { Stratus } from '@stratusjs/runtime/stratus';
import { isEqual } from 'lodash';
import 'angular-material';
import '../services/model';
import '../services/collection';
import '../services/registry';
import { Model } from '../services/model';
import { Collection } from '../services/collection';
import { Registry } from '../services/registry';
import { safeUniqueId } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
const min = !cookie('env') ? '.min' : '';
const name = 'base';
const localPath = '@stratusjs/angularjs/src/components';
Stratus.Components.Base = {
    transclude: {
        model: '?stratusBaseModel'
    },
    bindings: {
        elementId: '@',
        ngModel: '=',
        property: '@',
        target: '@',
        id: '@',
        manifest: '@',
        decouple: '@',
        direct: '@',
        api: '@',
        urlRoot: '@',
        limit: '@',
        options: '<'
    },
    controller($scope, $attrs) {
        $scope.uid = safeUniqueId(name);
        Stratus.Instances[$scope.uid] = $scope;
        $scope.elementId = $attrs.elementId || $scope.uid;
        Stratus.Internals.CssLoader(`${Stratus.BaseUrl + Stratus.BundlePath + localPath}/${name}${min}.css`).then();
        $scope.initialized = false;
        $scope.property = $attrs.property || null;
        $scope.data = null;
        $scope.model = null;
        $scope.collection = null;
        if ($attrs.target) {
            $scope.registry = $scope.registry || new Registry();
            $scope.registry.fetch($attrs, $scope).then();
        }
        $scope.$watch('$ctrl.ngModel', (data) => {
            if (data instanceof Model && data !== $scope.model) {
                $scope.model = data;
            }
            else if (data instanceof Collection && data !== $scope.collection) {
                $scope.collection = data;
            }
        });
        $scope.initialize = () => {
            if ($scope.initialized) {
                return;
            }
            if ($scope.model) {
                $scope.initialized = true;
                $scope.model.on('change', () => {
                    console.log('model changed:', $scope.model.patch);
                });
            }
            if ($scope.collection) {
                $scope.initialized = true;
                console.log('collection available');
            }
        };
        $scope.$watch('$scope.model.completed', (newVal, oldVal) => {
            if (!newVal || isEqual(newVal, oldVal)) {
                return;
            }
            $scope.initialize();
        });
        $scope.$watch('$scope.collection.completed', (newVal, oldVal) => {
            if (!newVal || isEqual(newVal, oldVal)) {
                return;
            }
            $scope.initialize();
        });
        if (cookie('env')) {
            console.log(name, 'component:', $scope, $attrs);
        }
    },
    templateUrl: `${Stratus.BaseUrl}${Stratus.DeploymentPath}${localPath}/${name}${min}.html`
};

//# sourceMappingURL=base.js.map
